import React from 'react';
import './HireUs.scss';
import PrimaryButton from "../../../../../components/Button/Button";
import { useMutation } from '@tanstack/react-query';
import { hireUsRequests } from '../../../../../sevices/violationsApi';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';

const HireUs = ({ params, refetch }) => {
  const { mutate: hireUs, isPending } = useMutation({
    mutationFn: hireUsRequests,
    onSuccess: () => {
      toast.success("Hire us request sent successfully");
      refetch();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const handleHireUs = () => {
    const data = {
      violation_id: params?.row?.violation.violation_id,
      client_id: params?.row?.client_id,
      unit_id: params?.row?.unit_id,
    };
    console.log(data);
    hireUs(data);
  };
  return (
    <div className="hire-us-container">
      {params?.row?.violation?.is_hire ? (
        <div className="request-sent-text">Request Sent</div>
      ) : (
        <PrimaryButton
          className="hire-us-btn"
          onClick={handleHireUs}
          disabled={isPending}
        >
          {isPending ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Hire Us"
          )}
        </PrimaryButton>
      )}
    </div>
  );
};

export default HireUs;